<template>
<div id="appdettaglio" v-cloak>

    <b-container fluid>
        <b-row>
            <b-col sm="12" md="8" lg="6" class="mx-auto text-center" style="width: 95%;margin-top:15px;">
                <b-card :header="(this.$route.params.id != null ? 'Impianto #' + this.$route.params.id : 'Nuovo impianto')">

                    <b-container fluid class="mx-auto text-left" v-if="showdettaglio2 && (showdettaglio1 || this.$route.params.id == null)">
                         <b-row class="my-1">
                            <b-col sm="3"><label for="nominativo">Nominativo:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="impianto.nominativo" id="nominativo" type="text"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="descrizione">Descrizione:</label></b-col>
                            <b-col sm="9">
                                <b-form-textarea id="descrizione" v-model="impianto.descrizione" :rows="2"></b-form-textarea>
                            </b-col>
                        </b-row>
                        <b-row class="my-1" v-show="(impianto.voto > 0)">
                            <b-col sm="3"><label for="voto">Voto medio:</label></b-col>
                            <b-col sm="9">
                                <star-rating id="voto" v-model="impianto.voto" read-only :increment="0.01" :star-size="25" :show-rating="true"></star-rating>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="note">Note:</label></b-col>
                            <b-col sm="9">
                                <b-form-textarea id="note" v-model="impianto.note" :rows="3"></b-form-textarea>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="msgpreno">Messaggio accettazione condizioni (es.: Covid):</label></b-col>
                            <b-col sm="9">
                                <b-form-textarea id="msgpreno" v-model="impianto.msgpreno" :rows="3"></b-form-textarea>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="indirizzo">Indirizzo:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="impianto.indirizzo" id="indirizzo" type="text"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="sitoweb">Sito web:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="impianto.sitoweb" id="sitoweb" type="text"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="facebook">Facebook:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="impianto.facebook" id="facebook" type="text"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="coordinate">Coordinate:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="impianto.coordinate" id="coordinate" type="text"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="telefono">Telefono:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="impianto.telefono" id="telefono" type="text"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="gruppowa">Link gruppo WhatsApp:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="impianto.gruppowa" id="gruppowa" type="text"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="email">Email:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="impianto.email" id="email" type="email"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="datainizio">Data inizio:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="impianto.datainizio" id="datainizio" type="date"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="datafine">Data fine:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="impianto.datafine" id="datafine" type="date"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="categoria">Categoria:</label></b-col>
                            <b-col sm="9">
                                <b-form-select v-model="impianto.id_categoria" :options="options_categorie" id="categoria">
                                    <template slot="first">
                                                <!-- this slot appears above the options from 'options' prop -->
                                                <option :value="null" disabled>-- Seleziona --</option>
                                    </template>
                                </b-form-select>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="giorniprima">Visibilità giorni prima:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="impianto.giorniprima" id="giorniprima" type="number"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="visibilità">Visibilità:</label></b-col>
                            <b-col sm="9">
                                <b-form-select v-model="impianto.visibilita" :options="options_visibilità" id="visibilità">
                                    <template slot="first">
                                                <!-- this slot appears above the options from 'options' prop -->
                                                <option :value="null" disabled>-- Seleziona --</option>
                                    </template>
                                </b-form-select>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="prenotabilità">Prenotabilità:</label></b-col>
                            <b-col sm="9">
                                <b-form-select v-model="impianto.prenotabilita" :options="options_prenotabilità" id="prenotabilità">
                                    <template slot="first">
                                                <!-- this slot appears above the options from 'options' prop -->
                                                <option :value="null" disabled>-- Seleziona --</option>
                                    </template>
                                </b-form-select>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="flgctrlcertmed">Controllo certificato medico:</label></b-col>
                            <b-col sm="9">
                                <b-form-select v-model="impianto.flgctrlcertmed" :options="options_flgctrlcertmed" id="flgctrlcertmed">
                                    
                                </b-form-select>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="flgctrlabbonamento">Controllo abbonamento valido:</label></b-col>
                            <b-col sm="9">
                                <b-form-select v-model="impianto.flgctrlabbonamento" :options="options_flgctrlabbonamento" id="flgctrlabbonamento">
                                    
                                </b-form-select>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="flgmaxpreno">Periodo controllo numero max prenotazioni:</label></b-col>
                            <b-col sm="9">
                                <b-form-select v-model="impianto.flgmaxpreno" :options="options_flgmaxpreno" id="flgmaxpreno">
                                    <template slot="first">

                                    </template>
                                </b-form-select>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="flgsocio2">Abilitazione dati secondo partecipante:</label></b-col>
                            <b-col sm="9">
                                <b-form-select v-model="impianto.flgsocio2" :options="options_flgsocio2" id="flgsocio2">
                                    <template slot="first">

                                    </template>
                                </b-form-select>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="nummaxpreno">Numero max prenotazioni nel periodo:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="impianto.nummaxpreno" id="nummaxpreno" type="number"></b-form-input>
                            </b-col>
                        </b-row>
                        
                        <b-row class="my-1">
                            <b-col sm="3"><label for="nummaxprenoora">Numero max prenotazioni per ora:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="impianto.nummaxprenoora" id="nummaxprenoora" type="number"></b-form-input>
                            </b-col>
                        </b-row>
                        
                        <b-row class="my-1">
                            <b-col sm="3"><label for="nummaxriservora">Numero max prenotazioni di riserva per ora:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="impianto.nummaxriservora" id="nummaxriservora" type="number"></b-form-input>
                            </b-col>
                        </b-row>

                        <b-row class="my-1">
                            <b-col sm="3"><label for="giorniprimapreno">Prenotabilità giorni prima:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="impianto.giorniprimapreno" id="giorniprimapreno" type="number"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="oramaxannulla">Ora massima per annullamento:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="impianto.oramaxannulla" id="oramaxannulla" type="time"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="giornimaxannulla">Giorni prima per annullamento:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="impianto.giornimaxannulla" id="giornimaxannulla" type="number"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="minutiiniora">Minuti iniziali fascia oraria:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="impianto.minutiiniora" id="minutiiniora" type="text" maxlength="2"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-3">
                            <b-col sm="4" offset-sm="3" v-if="impianto.id != null">
                                <b-button block size="md" variant="outline-secondary" v-on:click="orari()">
                                    Orari
                                </b-button>
                            </b-col>
                            <b-col sm="4" v-if="impianto.id != null">
                                <b-button block size="md" variant="outline-secondary" v-on:click="prenotazioni()">
                                    Prenotazioni
                                </b-button>
                            </b-col>                                                                                        
                        </b-row>      
                        <b-row class="my-3">                            
                            <b-col sm="4" offset-sm="3" v-if="impianto.id != null">
                                <b-button block size="md" variant="outline-secondary" v-on:click="voti()">
                                    Voti
                                </b-button>
                            </b-col>                                    
                            <b-col sm="4" v-show="impianto.id != null">
                                <b-button block size="md" variant="outline-secondary" v-on:click="allegatiImmagini()">
                                    Allegati e immagini
                                </b-button>
                            </b-col>                                    
                        </b-row>                                                                
                        <b-row class="my-1">
                            <b-col sm="5" offset-sm="3">
                                <b-button block size="md" variant="outline-primary" v-on:click="insert()">
                                    <div v-if="impianto.id != null">
                                        Salva
                                    </div>
                                    <div v-else>
                                        Inserisci
                                    </div>
                                </b-button>
                            </b-col>                                    
                        </b-row>
                    </b-container>

                    <b-alert :show="showerror" variant="danger">{{ error }}</b-alert>
                    <b-alert :show="dismissCountDown" dismissible variant="success" @dismissed="dismissCountdown=0" @dismiss-count-down="countDownChanged">
                        Operazione effettuata con successo
                    </b-alert>


                </b-card>
            </b-col>
        </b-row>
    </b-container>

</div>
</template>

<script>
import moment from 'moment'

import {
    ctrlVismenu,
    ctrlViscategoria
} from '../util.js'

import {
    NAMESPACE,
} from '../config.js'

import {
    Categoria,
    Visibilità,
    Prenotabilità
} from '../classes.js'



export default {
    name: 'appdettaglio',
    data: function () {
        return {
                        
            namespace: NAMESPACE,
            impianto: {
                id: this.$route.params.id || null,
                id_categoria: null,
                nominativo: '',
                visibilita: null,
                prenotabilita: null,
                descrizione: '',
                indirizzo: '',
                note: '',
                msgpreno: '',
                sitoweb: '',
                facebook: '',
                coordinate: '',
                telefono: '',
                email: '',
                datainizio: '',
                datafine: '',
                flgctrlcertmed: 'N',
                flgctrlabbonamento: 'N',
                giorniprima: 365,  
                giorniprimapreno: 365,  
                oramaxannulla: '23:59',
                giornimaxannulla: 1,  
                nummaxpreno: 99,
                flgmaxpreno: 'N',
                gruppowa: '',
                voto: 0,
                flgsocio2: 'N',
                minutiiniora: '00',
                nummaxprenoora: 1,
                nummaxriservora: 1,
            },
            parametri: null,
            options_categorie: [],            
            options_visibilità: [],
            options_prenotabilità: [],
            options_flgctrlcertmed: [{
                value: 'N',
                text: 'No'
            }, {
                value: 'S',
                text: 'Sì'
            }],
            options_flgctrlabbonamento: [{
                value: 'N',
                text: 'No'
            }, {
                value: 'S',
                text: 'Sì'
            }],
            options_flgsocio2: [{
                value: 'N',
                text: 'No'
            }, {
                value: 'S',
                text: 'Sì'
            }],
            options_flgmaxpreno: [{
                value: 'N',
                text: 'Nessuno'
            }, {
                value: 'G',
                text: 'Giornaliero'
            }, {
                value: 'S',
                text: 'Settimanale' 
            }, {
                value: 'M',
                text: 'Mensile'   
            }, {
                value: 'A',
                text: 'Annuale'        
            }],
            error: '',
            showerror: false,
            showdettaglio1: false,
            showdettaglio2: false,
            dismissSecs: 5,
            dismissCountDown: 0          
        };
    },
    methods: {
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown;
        },
        allegatiImmagini() {

            this.$router.push({
                path: `/app/allegati/id/${this.impianto.id}/tipo/${this.flagTipo}`
            });

        },
        voti() {

            this.$router.push({
                path: `/app/voti/id/${this.impianto.id}/tipo/${this.flagTipo}`
            });

        },  
        orari() {

            this.$router.push({
                path: `/app/orari/id/${this.impianto.id}/tipo/${this.flagTipo}`
            });

        },   
        prenotazioni() {

            this.$router.push({
                path: `/app/prenotazioni/id/${this.impianto.id}/tipo/${this.flagTipo}`
            });

        },               
        insert() {

                var appdettaglio = this;

                if (this.impianto.nominativo == "") {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Campo nominativo vuoto!";

                } else if (this.impianto.descrizione == "") {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Campo descrizione vuoto!";

                } else if (this.impianto.datainizio == "" || this.impianto.datainizio == null) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Campo data inizio vuoto!";

                } else if (this.impianto.datafine == "" || this.impianto.datafine == null) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Campo data fine vuoto!";
                
                } else if (this.impianto.datafine < this.impianto.datainizio) { //sono stringhe yyyy-mm-dd
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Data inizio maggiore di data fine!";

                } else if (this.impianto.id_categoria == null) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Categoria non selezionata!";

                } else if ((this.impianto.visibilita || '') == '') {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Visibilità non selezionata!";

                } else if ((this.impianto.prenotabilita || '') == '') {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Prenotabilità non selezionata!";

                } else if (this.impianto.giorniprima < 0) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Visibilità giorni prima < 0!";

                } else if (this.impianto.giorniprimapreno < 0) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Prenotabilità giorni prima < 0!";

                } else if (this.impianto.giornimaxannulla < 0) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Giorni prima per annullamento < 0!";
    

                } else if (this.impianto.nummaxpreno < 0) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Numero massimo prenotazioni < 0!";

                } else if (this.impianto.nummaxprenoora < 1) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Numero massimo prenotazioni per ora < 1!";

                } else if (this.impianto.nummaxriservora < 0) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Numero massimo prenotazioni di riserva per ora < 0!";

                } else if ((this.impianto.minutiiniora || '') == '') {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Campo minuti iniziali fascia oraria vuoto!";

                } else if (/*(!Number.isInteger(this.impianto.minutiiniora)) ||*/ parseInt(this.impianto.minutiiniora) < 0 || parseInt(this.impianto.minutiiniora) > 59) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Campo minuti iniziali fascia oraria deve contenere un valore di tipo numerico compreso tra 0 e 59!";

                } else {

                    var json = JSON.stringify(this.impianto);

                    var token = localStorage.getItem('token');
                    this.axios.post(NAMESPACE + 'rest/impianto', json, {
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': token
                            }
                        })
                        .then(response => {
                            // JSON responses are automatically parsed.
                            try {

                                if (!response.data.error) {

                                    if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                    var res = response.data.message;
                                    if (res.length > 0) {                                        
                                        this.impianto = res[0];
                                        this.showerror = false;
                                        this.showdettaglio1 = true; //anche se non dovrebbe servire                                 
                                        this.dismissCountDown = this.dismissSecs;

                                        this.$router.replace('/app/dettaglioimpianto/' + this.impianto.id);

                                    } else {
                                        throw new Error("Errore dati non trovati!");
                                    }


                                } else {
                                    throw new Error(response.data.message);
                                }


                            } catch (e) {
                                this.showerror = true;
                                this.error = "Errore: " + e.message;
                            }

                        })
                        .catch(e => {
                            this.showerror = true;
                            this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                        });

                }

            }


    },    
    created: function () {

        

            if(!ctrlVismenu("I")){
                this.$router.replace('/accessdenied');
                return;
            }



            var appdettaglio = this;

            var token = localStorage.getItem('token');             
            var id = this.impianto.id; //se è la prima volta si prova a prendere da getid 

            if (id != null) {
                               
                this.axios.get(NAMESPACE + 'rest/impianti/' + id, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token
                        }
                    })
                    .then(response => {
                        // JSON responses are automatically parsed.
                        try {

                            if (!response.data.error) {

                                if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                var res = response.data.message;
                                if (res.length > 0) {

                                    if (this.$route.params.duplica == 'true') {
                                        res[0].id = null;                                       
                                        res[0].voto = 0;
                                    }
                                    this.impianto = res[0];
                                    this.showdettaglio1 = this.showdettaglio2 = true;

                                } else {
                                    throw new Error("Errore dati non trovati!");
                                }


                            } else {
                                throw new Error(response.data.message);
                            }


                        } catch (e) {
                            appdettaglio.showerror = true;
                            appdettaglio.error = "Errore: " + e.message;
                        }

                    })
                    .catch(e => {
                        appdettaglio.showerror = true;
                        appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                    });

            }

             //////////////////////////////////////
            const tipoPagina = 'Impianto';
            //////////////////////////////////////

            //creo la tendina visibilità
            var visibilità = new Visibilità();
            var options_vis = [];
            for (var i = 0; i < Object.keys(visibilità.getListaTipi()).length; i++) {
                options_vis.push({
                    value: Object.keys(visibilità.getListaTipi())[i],
                    text: visibilità.getTipoByFlag(Object.keys(visibilità.getListaTipi())[i])
                });
            }
            this.options_visibilità = options_vis;

            //creo la tendina prenotabilità
            var prenotabilità = new Prenotabilità();
            var options_pre = [];
            for (i = 0; i < Object.keys(prenotabilità.getListaTipi()).length; i++) {
                options_pre.push({
                    value: Object.keys(prenotabilità.getListaTipi())[i],
                    text: prenotabilità.getTipoByFlag(Object.keys(prenotabilità.getListaTipi())[i])
                });
            }
            this.options_prenotabilità = options_pre;

            //recupero il valore del flag del tipo della categoria
            var cat = new Categoria();
            var tipi = cat.getListaTipi();
            var keys = Object.keys(tipi);
            var flagTipo = "";
            for (i = 0; i < keys.length; i++) {
                if (tipi[keys[i]] == tipoPagina) {
                    flagTipo = keys[i];
                }
            }

            this.flagTipo = flagTipo;

            //chiamo il servizio che mi restituisce tutte le categorie di quel tipo
            this.axios.get(NAMESPACE + 'rest/categorie/tipo/' + flagTipo, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {

                        if (!response.data.error) {

                            if (response.data.token != null) localStorage.setItem('token', response.data.token);

                            var res = response.data.message;
                            if (res.length > 0) {

                                var options = [];
                                for (var i = 0; i < res.length; i++) {
                                    options.push({
                                        value: res[i].id,
                                        text: res[i].descrizione
                                    });
                                }

                                this.options_categorie = options;

                                this.options_categorie = this.options_categorie.filter(function (element) {                       
                                    return ctrlViscategoria(element.value);
                                });

                                this.showdettaglio2 = true;

                            } else {
                                throw new Error("Errore categorie non trovate!");
                            }


                        } else {
                            throw new Error(response.data.message);
                        }


                    } catch (e) {
                        appdettaglio.showerror = true;
                        appdettaglio.error = "Errore: " + e.message;
                    }

                })
                .catch(e => {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                });

    },    
    mounted: function() {
        
        
        
    }

}
</script>
